import type { Statement } from '../shared'

/** Closed wire vocabulary. Human detail never belongs in a durable receipt. */
export const refusalCodes = ['ROW_PERMISSION_DENIED', 'TRANSACTION_REFUSED', 'PAYLOAD_TOO_LARGE', 'E_NAME_COLLISION', 'E_OBJECT_MISSING', 'E_USING_UNKNOWN_FUNCTION', 'E_USING_UNSUPPORTED', 'E_USING_FOREIGN_TABLE', 'E_USING_CLOCK', 'E_USING_IMPLICIT_CLOCK', 'TABLE_VERSION_REFUSED'] as const
export type RefusalCode = typeof refusalCodes[number]
export const refusalReasonBytes = 64

export function isRefusalCode(value: unknown): value is RefusalCode {
  return typeof value === 'string' && value.length <= refusalReasonBytes && /^[\u0020-\u007E]+$/.test(value) && refusalCodes.some(code => code === value)
}

export function validateRefusals(rows: { index: number; reason: string }[], rowCount?: number): void {
  if (rows.length === 0 || rowCount !== undefined && rows.length !== rowCount || rows.some((row, index) => row.index !== index || !isRefusalCode(row.reason))) throw new Error('Invalid row refusal receipt')
}

/** Runs inside the atomic publication batch. Invalid policy output aborts every write. */
export function validatedRefusalSql(source: Statement, rowCount?: number): Statement {
  const codes = refusalCodes.map(code => `'${code}'`).join(',')
  return { sql: `WITH refusal(refusal_json) AS MATERIALIZED (SELECT (${source.sql}))
    SELECT CASE WHEN json_valid(refusal_json) AND json_type(refusal_json)='array' AND json_array_length(refusal_json)>0
      ${rowCount === undefined ? '' : `AND json_array_length(refusal_json)=${rowCount}`}
      AND NOT EXISTS(SELECT 1 FROM json_each(refusal_json) WHERE json_type(json_each.value,'$.index') IS NOT 'integer'
        OR json_extract(json_each.value,'$.index')<>CAST(json_each.key AS INTEGER)
        OR json_type(json_each.value,'$.reason') IS NOT 'text'
        OR json_extract(json_each.value,'$.reason') NOT IN (${codes}))
      THEN refusal_json ELSE json('Invalid row refusal receipt') END FROM refusal`, params: source.params }
}
